var _module_exports = "<ng-transclude ng-click=\"$ctrl.open()\"></ng-transclude>";;
var path = '/app/components/modals/open-modal.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;